module.exports = __webpack_public_path__ + "static/media/lingoqImg.8b9531a3.png";